const DateRender = {
  data() {
    return {
      dateFormatOptions: {
        day: 'numeric',
        year: 'numeric',
        month: 'long',
      },
    };
  },
  methods: {
    /**
     * @param {String} date
     * @param {String} onError
     * @returns {String}
     */
    stringDateToText(date, onError='Данные отсутствуют') {
      try {
        const result = new Date(date).toLocaleString('ru-RU', this.dateFormatOptions);
        return result;
      }
      catch {
        return onError;
      }
    }
  },
};

export default DateRender;
